import React, { useEffect } from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import { useSelector } from "react-redux";

import "./css/SuccessScreen.css";


function SuccessScreen() {

  const navigate = useNavigate();

  const {
    restaurantId,
    tableId,
  } = useParams();


  const {
    order,
  } = useSelector(
    (state) => state.order
  );


  // =====================================================
  // AUTO REDIRECT AFTER 10 SECONDS
  // =====================================================

  useEffect(() => {

    const timer = setTimeout(() => {

      navigate(
        `/${restaurantId}/table/${tableId}`
      );

    }, 10000);


    return () => {

      clearTimeout(timer);

    };

  }, [
    navigate,
    restaurantId,
    tableId,
  ]);


  // =====================================================
  // PAGE
  // =====================================================

  return (

    <div className="success-page">

      <div className="success-container">


        {/* SUCCESS ICON */}

        <div className="success-icon">
          ✓
        </div>


        {/* TITLE */}

        <h1>
          Order Confirmed
        </h1>


        {/* MESSAGE */}

        <p>
          Your order has been successfully placed.
        </p>


        {/* ORDER NUMBER */}

        {order && (

          <div className="success-order">

            <span>
              Order Number
            </span>


            <strong>
              #{order.order_number}
            </strong>

          </div>

        )}


        {/* AUTO REDIRECT MESSAGE */}

        <p>
          Returning to menu in 10 seconds...
        </p>


        {/* BACK TO MENU */}

        <button
          type="button"
          onClick={() =>
            navigate(
              `/${restaurantId}/table/${tableId}`
            )
          }
        >
          Back to Menu
        </button>


      </div>

    </div>

  );

}


export default SuccessScreen;